// authInterceptor.js
import axios from 'axios';
import { authenticationService } from '../services/authentication.service';
import { spinnerService } from '../services/spinner.service';
import { toast } from 'react-toastify';

// Create axios instance
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASEURL_GET || 'http://localhost:8000/api',
});

// Helper function to control spinner
const controlSpinner = bolValue => {
  if (bolValue === true) {
    spinnerService.showSpinner();
  } else {
    spinnerService.disableSpinner();
  }
};

// Request interceptor - add token and show spinner
apiClient.interceptors.request.use(
  config => {
    const token = authenticationService.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    controlSpinner(true);
    return config;
  },
  error => {
    controlSpinner(false);
    return Promise.reject(error);
  }
);

// Response interceptor - handle errors and hide spinner
apiClient.interceptors.response.use(
  response => {
    controlSpinner(false);
    return response;
  },
  error => {
    controlSpinner(false);

    const status = error.response?.status;
    const errorMessage = error.response?.data?.msg;

    // Handle 401/403 authentication errors
    if (status === 401 || error.response?.data?.auth === false) {
      // Logout user
      authenticationService.logout();

      // Get current path and redirect to login with returnUrl
      const currentPath = window.location.pathname + window.location.search;
      const returnUrl = encodeURIComponent(currentPath);

      window.location.href = `/login?returnUrl=${returnUrl}`;
      return Promise.reject(error);
    }

    if (status === 403) {
      // Note: You'll need to pass logicContext or use a toast service
      toast.error('Authentication token expired!');
           authenticationService.logout();

           // Get current path and redirect to login with returnUrl
           const currentPath = window.location.pathname + window.location.search;
           const returnUrl = encodeURIComponent(currentPath);

           window.location.href = `/login?returnUrl=${returnUrl}`;
           return Promise.reject(error);
    }

    // Handle other error codes
    if (status === 422) {
      toast.info(`error : ${errorMessage || 'Something went wrong, please contact Admin'}`);
    } else if (status === 404) {
      toast.error(`Error: ${errorMessage || 'Something went wrong, please contact Admin'}`);
    } else if (status === 400) {
      
      toast.error(`Error: ${errorMessage || 'Something went wrong, please contact Admin'}`);
    } else if (status === 503) {
      toast.info(`Requirement: ${errorMessage || 'Something went wrong, please contact Admin'}`);
    } else if (status === undefined) {
      toast.warning(`Error: ${errorMessage || 'Something went wrong, please contact Admin'}`);
    } else {
      toast.error('Connection error');
    }

    return Promise.reject(error);
  }
);

export default apiClient;
